import React, { FC } from 'react'

import {
  CreditCardManager,
  ExpenseBucket,
  PointsCard,
} from 'src/payments/components'

import styles from './styles'
import { useActions, useEffect, useQueries, useVertical } from '../../../hooks'
import { getAccount } from 'src/graphql'
import suspenseBoundary from 'src/chrome/SuspenseBoundary/suspenseBoundaryHOC'
import { DefaultError } from 'src/chrome'
import { Spacer, Text } from '@sendoutcards/quantum-design-ui'

const PaymentSettings: FC = () => {
  const actions = useActions()
  const [account] = useQueries(getAccount())
  const isClientSOC = useVertical().id === 'soc'

  useEffect(() => {
    actions.updatedAccount(account)
  }, [actions, account])

  return (
    <div css={styles.paymentWrapper}>
      <Text type="title">My Wallet</Text>
      <Spacer space="x9" />
      <div css={styles.cardsContainer}>
        <div css={styles.cardSection}>
          <div css={styles.blah}>
            <Text type="body" color="primaryHeading" weight="bold">
              Primary Payment
            </Text>
            <Spacer space="x3" />
            <Text type="caption">
              Used for purchasing products and monthly subscriptions
            </Text>
          </div>
          <CreditCardManager />
        </div>
        {isClientSOC && (
          <div>
            <div css={styles.blah}>
              <Text type="body" color="primaryHeading" weight="bold">
                Expense Bucket
              </Text>
              <Spacer space="x3" />
              <Text type="caption">
                Used for postage, shipping, and handling
              </Text>
            </div>
            <ExpenseBucket account={account} />
          </div>
        )}
      </div>
      {!account.isNewUser && isClientSOC && (
        <div css={{ ...styles.cardSection, marginTop: 50 }}>
          <div css={styles.blah}>
            <Text type="body" color="primaryHeading" weight="bold">
              Your Points
            </Text>
            <Spacer space="x3" />
            <Text type="caption">
              Points are used for sending cards and gifts
            </Text>
          </div>
          <PointsCard />
        </div>
      )}
    </div>
  )
}

export default suspenseBoundary({
  component: PaymentSettings,
  unresolved: (
    <Text type="caption" alignment="center">
      Loading account...
    </Text>
  ),
  failure: DefaultError,
})
